import { LANGUAGES } from '../constants';
import type { LanguageCode } from '../types';

export function checkLanguageCode(code: string): code is LanguageCode {
  return code in LANGUAGES;
}
